import React from 'react'
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItemButton,
  ListItemText,
  Chip,
  Divider,
} from '@mui/material'
import { Business } from '@mui/icons-material'

const ROLE_LABELS = {
  admin: 'Administrator',
  manager: 'Manager',
  accountant: 'Buchhalter',
  readonly: 'Lesezugriff',
}

const ROLE_COLORS = {
  admin: 'error',
  manager: 'primary',
  accountant: 'secondary',
  readonly: 'default',
}

function switchTenant(tenantId, csrfToken) {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = '/core/tenant_switch'

  const fields = {
    authenticity_token: csrfToken || '',
    _method: 'patch',
    tenant_id: tenantId,
  }

  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  })

  document.body.appendChild(form)
  form.submit()
}

export default function TenantSelect({ tenants = [] }) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Business sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
        <Typography variant="h5" component="h1" fontWeight={700} gutterBottom>
          Mandant auswählen
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Bitte wählen Sie den Mandanten, mit dem Sie arbeiten möchten.
        </Typography>

        <Paper elevation={2} sx={{ width: '100%' }}>
          <List disablePadding>
            {tenants.map((tenant, index) => (
              <React.Fragment key={tenant.id}>
                {index > 0 && <Divider />}
                <ListItemButton
                  onClick={() => switchTenant(tenant.id, csrfToken)}
                  sx={{ py: 2, px: 3 }}
                  data-testid={`tenant-option-${tenant.slug}`}
                >
                  <ListItemText
                    primary={tenant.name}
                    primaryTypographyProps={{ fontWeight: 500 }}
                    secondary={tenant.slug}
                  />
                  <Chip
                    label={ROLE_LABELS[tenant.role] || tenant.role}
                    color={ROLE_COLORS[tenant.role] || 'default'}
                    size="small"
                    variant="outlined"
                  />
                </ListItemButton>
              </React.Fragment>
            ))}
          </List>
        </Paper>
      </Box>
    </Container>
  )
}
